import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import ApiService from 'redux/services/api-service';

export interface IState {
  items: any[];
  configurations: any[];
  loading: boolean;
}

export const inventoryItemListEndpoints = {
  createInventoryItemList: createAsyncThunk('inventoryItemList/createInventoryItemList', async (payload: any) => {
    const response = await ApiService.post(`/p_inventory/item_list/`, payload);
    return response.data;
  }),
  updateInventoryItemList: createAsyncThunk('inventoryItemList/updateInventoryItemList', async (payload: any) => {
    const response = await ApiService.put(`/p_inventory/item_list/${payload.item_list_id}/`, payload);
    return response.data;
  }),
  getInventoryItemList: createAsyncThunk('inventoryItemList/getInventoryItemList', async (payload: any) => {
    const response = await ApiService.get(`/p_inventory/item_list/?${new URLSearchParams(payload).toString()}`);
    return response.data;
  }),
  deleteInventoryItemList: createAsyncThunk(
    'inventoryItemList/deleteInventoryItemList',
    async (id: string | number) => {
      const response = await ApiService.delete(`/p_inventory/item_list/${id}/`);
      return response.data;
    },
  ),
  getInventoryItems: createAsyncThunk('inventoryItemList/getInventoryItems', async (payload: any) => {
    const response = await ApiService.get(`/p_inventory/item/?${new URLSearchParams(payload).toString()}`);
    return response.data;
  }),
  createInventoryItemListConfiguration: createAsyncThunk(
    'inventoryItemList/createInventoryItemListConfiguration',
    async (payload: any) => {
      const response = await ApiService.post(`/p_inventory/item_list_configuration/`, payload);
      return response.data;
    },
  ),
  getInventoryItemListConfigurations: createAsyncThunk(
    'inventoryItemList/getInventoryItemListConfigurations',
    async (params: any) => {
      const response = await ApiService.get(
        `/p_inventory/item_list_configuration?${new URLSearchParams(params).toString()}`,
      );
      return response.data;
    },
  ),
  deleteInventoryItemListConfiguration: createAsyncThunk(
    'inventoryItemList/deleteInventoryItemListConfiguration',
    async (id: number) => {
      const response = await ApiService.delete(`/p_inventory/item_list_configuration/${id}`);
      return response.data;
    },
  ),
  submitInventoryItemListConfiguration: createAsyncThunk(
    'inventoryItemList/submitInventoryItemListConfiguration',
    async (payload: any) => {
      const response = await ApiService.post(`p_inventory/submit_inventory/`, payload);
      return response.data;
    },
  ),
};
export const inventoryItemListSlice = createSlice({
  name: 'inventoryItemList',
  initialState: {
    items: [],
    configurations: [],
    loading: false,
  } as IState,
  reducers: {
    clearInventoryItems(state) {
      state.items = [];
    },
    clearInventoryItemListConfiguration(state) {
      state.configurations = [];
    },
  },
  extraReducers: builder => {
    builder
      .addCase(inventoryItemListEndpoints.getInventoryItems.fulfilled, (state, {payload}) => {
        state.loading = false;
        state.items = payload.results;
      })
      .addCase(inventoryItemListEndpoints.getInventoryItems.pending, state => {
        state.loading = true;
      })
      .addCase(inventoryItemListEndpoints.getInventoryItems.rejected, state => {
        state.loading = false;
      })

      .addCase(inventoryItemListEndpoints.getInventoryItemListConfigurations.fulfilled, (state, {payload}) => {
        state.loading = false;
        state.configurations = payload.results;
      })
      .addCase(inventoryItemListEndpoints.getInventoryItemListConfigurations.pending, state => {
        state.loading = true;
      })
      .addCase(inventoryItemListEndpoints.getInventoryItemListConfigurations.rejected, state => {
        state.loading = false;
      })
      .addCase(inventoryItemListEndpoints.deleteInventoryItemListConfiguration.fulfilled, (state, {payload}) => {
        state.loading = false;
        state.configurations = state.configurations.filter(it => it.id !== payload);
      });
  },
});

export const inventoryItemListActions = inventoryItemListSlice.actions;

export type InventoryItemListSlice = {
  [inventoryItemListSlice.name]: ReturnType<(typeof inventoryItemListSlice)['reducer']>;
};
